import React from "react";
import {SelectId} from "./SelectId";
import {Select} from "./Select";

const campaignStatusOptions = [
    { id: 'Draft', label: 'Draft' },
    { id: 'Quote', label: 'Quote' },
    { id: 'Cancelled', label: 'Cancelled' },
    { id: 'Confirmed', label: 'Confirmed' },
    { id: 'To invoice', label: 'To invoice' },
    { id: 'Invoiced', label: 'Invoiced' },
    { id: 'Paid', label: 'Paid' },
    { id: 'Part Invoiced', label: 'Part Invoiced' }
];
export function CampaignStatusSelect(props) {
    return props.valueIsId?
        <SelectId options={campaignStatusOptions} {...props} labelField="label" />:
        <Select options={campaignStatusOptions} {...props} labelField="label" />;
}